export default "__VITE_ASSET__CMkFT2bG__"